import { Dropdown, TextField } from '@fluentui/react';
import * as React from 'react';

import { MachineLearningExperimentType } from '../../../../Common/MachineLearningModels/IMachineLearningExperiment';
import * as FormStyle from '../../../../Common/Styles/form.styled';
import { useGetAllDataOwners } from '../../../../Hooks/DataOwner/useGetAllDataOwners';
import { MachineLearningExperimentWizardStep } from './MachineLearningExperimentWizard';
import {
  MachineLearningExperimentWizardContext,
  MachineLearningExperimentWizardContextProps,
} from './MachineLearningExperimentWizardContext';

export function MachineLearningExperimentInfoWizardStep(): React.ReactElement {
  const { experiment, setExperiment, setCompletedSteps, completedSteps } =
    React.useContext<MachineLearningExperimentWizardContextProps>(MachineLearningExperimentWizardContext);
  const [dataOwners] = useGetAllDataOwners(false);

  const handleFormUpdated = (name: string, value: string | MachineLearningExperimentType) => {
    setExperiment({
      ...experiment,
      [name]: value,
    });
  };

  React.useEffect(() => {
    if (
      !!experiment.dataOwnerId &&
      !!experiment.name &&
      !!experiment.type &&
      completedSteps.indexOf(MachineLearningExperimentWizardStep.INFO) === -1
    ) {
      setCompletedSteps([...completedSteps, MachineLearningExperimentWizardStep.INFO]);
    }
  }, [completedSteps, experiment, setCompletedSteps]);

  return (
    <FormStyle.MinimumForm>
      <FormStyle.InputGroup>
        <h2>General information</h2>
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <Dropdown
          label="Data owner"
          options={(dataOwners || []).map((dataOwner) => ({
            key: dataOwner.id,
            text: dataOwner.name,
          }))}
          placeholder="Select a data owner"
          onChange={(e, option) => handleFormUpdated('dataOwnerId', option.key.toString())}
          selectedKey={experiment.dataOwnerId}
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <Dropdown
          label="Machine learning project type"
          options={[
            {
              key: 'Data Anomaly Detection',
              text: MachineLearningExperimentType.DataAnomalyDetection,
            },
            {
              key: 'Timeseries Forecasting',
              text: MachineLearningExperimentType.TimeseriesForecasting,
              disabled: true,
            },
          ]}
          selectedKey={experiment.type}
          onChange={(e, option) => handleFormUpdated('type', option.key.toString())}
          placeholder="Select machine learning project type"
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="Name"
          id="name"
          required={true}
          value={experiment.name}
          onChange={(e, value) => handleFormUpdated('name', value)}
          validateOnLoad={false}
          validateOnFocusOut={true}
        />
      </FormStyle.InputGroup>

      <FormStyle.InputGroup>
        <TextField
          label="Description"
          id="description"
          placeholder="Describe the purpose of the machine learning project"
          required={true}
          multiline={true}
          value={experiment.description}
          onChange={(e, value) => handleFormUpdated('description', value)}
          validateOnLoad={false}
          validateOnFocusOut={true}
        />
      </FormStyle.InputGroup>
    </FormStyle.MinimumForm>
  );
}
